import type { UsersFilters } from '@/api/users/usersQueries';
import { FilterOptionButton } from '@/components/common/FilterButtons';
import { Input } from '@/components/common/Input';
import { useEffect, useState } from 'react';

type RoleFilter = 'Doctor' | 'Customer';

const ROLE_FILTERS: Array<{ label: string; value: RoleFilter }> = [
  { label: 'Doctors', value: 'Doctor' },
  { label: 'Patients', value: 'Customer' },
];

interface AssigningModificationsFiltersProps {
  filters: UsersFilters;
  onFiltersChange: (filters: UsersFilters) => void;
}

export function AssigningModificationsFilters({
  filters,
  onFiltersChange,
}: AssigningModificationsFiltersProps) {
  const [activeRole, setActiveRole] = useState<RoleFilter>('Doctor');
  const [nameSearch, setNameSearch] = useState('');
  const [emailSearch, setEmailSearch] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      onFiltersChange({
        ...filters,
        search: nameSearch || undefined,
        email: emailSearch || undefined,
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [nameSearch, emailSearch]);

  const handleRoleChange = (role: RoleFilter) => {
    setActiveRole(role);
    onFiltersChange({
      ...filters,
      role,
    });
  };

  const handleNameKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onFiltersChange({
        ...filters,
        search: nameSearch || undefined,
      });
    }
  };

  const handleEmailKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onFiltersChange({
        ...filters,
        email: emailSearch || undefined,
      });
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {ROLE_FILTERS.map((filter) => (
          <FilterOptionButton
            key={filter.value}
            label={filter.label}
            isActive={activeRole === filter.value}
            onClick={() => handleRoleChange(filter.value)}
          />
        ))}
      </div>

      <div className="flex gap-4">
        <div className="w-56">
          <Input
            id="name-filter"
            label="Filter by Name"
            placeholder="Filter by Name"
            className="bg-white"
            value={nameSearch}
            onChange={(e) => setNameSearch(e.target.value)}
            onKeyDown={handleNameKeyPress}
          />
        </div>
        <div className="w-56">
          <Input
            id="email-filter"
            label="Filter by Email"
            placeholder="Filter by Email"
            className="bg-white"
            value={emailSearch}
            onChange={(e) => setEmailSearch(e.target.value)}
            onKeyDown={handleEmailKeyPress}
          />
        </div>
      </div>
    </div>
  );
}
